export enum NewCardFieldName {
  pan = "ctpNewCardPan",
  expiryMonth = "ctpNewCardExpiryMonth",
  expiryYear = "ctpNewCardExpiryYear",
  securityCode = "ctpNewCardSecurityCode",
}
